// extracted by mini-css-extract-plugin
export default {"hideLegalDisclaimer":"wiseOwl_hideLegalDisclaimer__EBPfb","showLegalDisclaimer":"wiseOwl_showLegalDisclaimer__4KAyO"};